<template>
    <section class="pt-2">
        <div class="row mx-0">
            <div v-if="dataTable.length" class="col-12">
                <tabla-general alto="calc(100vh - 360px)" :data="dataTable" :activar-seleccion="true" @seleccion="abrirModal">
                    <template slot="cabecera-izquierda">
                        <p class="col-auto py-2 text-general f-18 f-600">Lista de retiros aprobados</p>
                    </template>
                    <template slot="adicionales-derecha">
                        <template>
                            <el-table-column label="" class-name="f-16 text-general text-center" width="50">
                                <template slot-scope="{ row }">
                                    <i class="f-20 text-orange" :class="{ 'icon-format-list-checks' : row.estado == 3}" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="tipo" label="Tipo" class-name="f-16 text-general text-center" width="125" />
                            <el-table-column prop="producto_desc" label="Producto" class-name="f-16 text-general text-left" width="500" />
                            <el-table-column label="Cantidad" class-name="f-16 text-general text-center" width="100">
                                <template slot-scope="{ row }">
                                    <p class="text-right">
                                        {{ agregarSeparadoresNumero(row.cantidad) }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Valor" class-name="f-16 text-general text-center" width="125">
                                <template slot-scope="{ row }">
                                    <p class="text-right">
                                        {{ separadorNumero(row.total) }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column label="Fecha Creación" class-name="f-16 text-general text-center" width="200">
                                <template slot-scope="{ row }">
                                    <p class="text-right">
                                        {{ formatearFecha(row.created_at) }}
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="leechero" :label="$config.vendedor" class-name="f-16 text-general text-left" width="200" />
                            <el-table-column prop="cedis_origen" label="Cedis" class-name="f-16 text-general text-left" width="200" />
                            <el-table-column prop="cedis_destino" label="Destino" class-name="f-16 text-general text-left" />
                        </template>
                    </template>
                </tabla-general>
                <!-- Sin Datos -->
            </div>
            <div v-else class="col-12">
                <sin-datos icon="list" mensaje="No hay datos para mostrar." />
            </div>
        </div>
        <!-- Modales -->
        <modal-informacion-compra ref="modalInformacionCompra" />
        <!-- Modales -->
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Retiros from "~/services/retiros";
export default {
    components: {
        modalInformacionCompra: () => import('./partials/modalInformacionCompra')
    },
    data(){
        return{
            dataTable: [],
        }
    },
    computed: {
        ...mapGetters({
            id_cedis:'cedis/id_cedis',
            id_moneda:'cedis/id_moneda',
        }),
    },
    watch: {
        id_moneda(val,oldVal){
            if (oldVal == null) return
            if(val == null) return
            this.montar()
        },
        id_cedis(val,oldVal){
            if (oldVal == null) return
            if(val == null) return
            this.montar()
        }
    },
    mounted(){
        this.montar()
    },
    methods: {
        async montar(){
            try {
                if(this.id_cedis === null || this.id_moneda === null){
                    setTimeout(async() => {
                        await this.retirosAprobados()
                    }, 1000);
                }else{
                    await this.retirosAprobados()
                }
            } catch (error){
                this.error_catch(error)
            }finally{
            }
        },
        abrirModal(row){
            let tab = row.id_cedis ? 1 : 2
            this.$refs.modalInformacionCompra.toggle(row.id, tab);
        },
        async retirosAprobados(){
            try {
                let params = {
                    id_moneda: this.id_moneda,
                    id_cedis: this.id_cedis
                }
                const { data } = await Retiros.retirosAprobados(params)
                this.dataTable = data.retiros
            } catch (error){
                this.error_catch(error)
            }
        },
        push(row){
            console.log(row);
        }
    }
}
</script>

<style lang="scss">
.br-12{
    border-radius: 12px;
}
</style>
